import React, { Fragment } from "react";
import { inject, observer } from "mobx-react";
import {
    Button, Grid, Typography, Switch,
    Chip, FormControlLabel, Checkbox, Radio, RadioGroup, FormControl,
    Dialog, DialogTitle, DialogContent, DialogActions
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import SimpleDatePicker from "../fields/SimpleDatePicker";
import Loading from "../loadingSpinner/Loading";
import { withRouter } from "react-router-dom";
import { ProfileType, LegalEntityType } from "../../types/enum";
import { legalEntityHasSuper, legalEntityIsSoleTrader } from "../../helper/legalEntityHelper";
import { superAbnFormatError, superBsbFormatError } from "../../helper/superannuationValidation";
import HubTimepicker2 from "../timepicker/HubTimepicker2";
import moment from "moment";
import ConfirmationModal from "../modal/ConfirmationModal";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DateTimePicker, DatePicker } from "material-ui-pickers";

import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import SelectField from "../fields/SelectField";
import Countries from "../../lookup/Country";
import SectionHeader from "../common/SectionHeader";

const feeTransparancy = "Choose whether to show or hide venue, agency or artist fees for the venues and artists you book. This lets you control who sees financial details, keeping your bookings as transparent as you need."

const venueIncomingInvoice = "Use this section to manage your artist and agent incoming invoices batching. If your legal entity differs from your venue name, you can add that here.  All incoming invoices will be addressed to this legal entity."
const agentIncomingInvoice = "Use this section to manage your artist's incoming invoices batching. If your legal entity for incoming invoices is different from your agency name, you can set that here. This entity will be applied to all invoices coming from your artists."
const musicianIncomingInvoice = "Use this section to manage your player’s incoming invoices batching. If your legal entity for incoming invoices is different from your profile name, you can set that here. This entity will be applied to all invoices coming from your players."

const agencyOutgoingInvoice = "Use this section to manage your outgoing invoices to venues and clients. If your outgoing invoicing entity is different to your agency name, you can set that here.  This entity will be applied  to your outgoing invoices."
const musicianOutgoingInvoice = "Use this section to manage your outgoing invoices to venues and clients. If your outgoing invoicing entity is different to your agency name, you can set that here.  This entity will be applied  to your outgoing invoices."

const legalEntitySuggestions = [
    {
        value: 0,
        label: "Not Set"
    },
    {
        value: 1,
        label: "Sole Trader"
    },
    {
        value: 2,
        label: "Partnership"
    },
    {
        value: 3,
        label: "Company"
    },
    {
        value: 4,
        label: "Trust"
    },
    {
        value: 5,
        label: "Hobbyist"
    }
]

const legalEntitySuggestionsWithSuper = [
    {
        value: 1,
        label: "Sole Trader"
    },
    {
        value: 2,
        label: "Partnership"
    },
    {
        value: 3,
        label: "Company"
    },
    {
        value: 4,
        label: "Trust"
    },
    {
        value: 5,
        label: "Hobbyist"
    }
]


@inject("financialProfileStore", "templateStore", "authStore", "profileStore", "organisationStore", "hgSuperPayAddonStore", "hgBillingStore")
@withRouter
@observer
class Financial extends React.Component {
    state = {
        isLoading: true,
        taxOptions: [],
        dialogAutoSendPopUp: false,
        dialogAutoSendOffPopUp: false,
        legalEntityChange: false,
        openConfirmationDialog: false,
        isTaxEditable: false,
        taxFileNumberError: false,
        taxFileNumberHelperText: '',
        tcDialogOpen: false,
    };

    initMap(){
        const gmapScriptEl = document.createElement(`script`)
        gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB7f0cc3w1EyMBqq0kn_fIvf6XPKzi8VWE&libraries=places&callback=initMap`
        document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl)
        window.scrollTo(0, 0);
    }
    handleChangelegalEntity = value => {
        if(legalEntityHasSuper(value) || legalEntityHasSuper(this.props.financialProfileStore.legalEntity)){
            this.setState({
                legalEntityChange: true
            })
        }
        this.props.financialProfileStore.setlegalEntity(value);
       
    };
   

    componentDidMount() {
        this.initMap()

        if (this.props.type === "agent" || this.props.type === "musician" || this.props.type === "act" || this.props.type === "venue") {
            this.props.hgSuperPayAddonStore.loadAddonStatus();
            this.props.hgBillingStore.loadAccess();
        }

        this.props.financialProfileStore.getAllSuperAnnuation()
        // set type
        this.props.financialProfileStore.setType(this.props.templateStore.getType(this.props.type));
        this.props.financialProfileStore
            .loadInitialData(this.props.profileId)
            .then(() => {
                this.resolveDefaultSuperPaymentMethod();
                if(!this.props.financialProfileStore.superAnnuationProfile.taxFileNumber){
                    this.setState({ isTaxEditable: true });
                }
                if (this.props.financialProfileStore.currency === '') {
                    if (!this.props.organisationStore.id) {
                        this.props.organisationStore.loadOrganisations().then(res => {
                            if (res.length > 1) {
                                this.props.financialProfileStore.setCurrency(res[0].Currency)
                            } else {
                                this.props.financialProfileStore.setCurrency("AUD")
                            }
                        }) 
                    } else {
                        this.props.financialProfileStore.setCurrency(this.props.organisationStore.currency)
                    }
                }
            })
            .finally(() => {
                this.setState({ isLoading: false });
                window.scrollTo(0, 0);
            });
    }

    resolveDefaultSuperPaymentMethod() {
        const store = this.props.financialProfileStore;
        if (store.superPaymentMethod) return;
        if (store.paymentType === 1) {
            store.setSuperPaymentMethod("xero");
        } else if (store.paymentType === 2) {
            store.setSuperPaymentMethod("hgSuperPay");
        }
    }

    handleSuperFundMemberNumber = (e) => {
        this.props.financialProfileStore.setSuperFundMemberNumber(e.target.value)
    }
    handleSuperProviderChange = (value) => {
        this.props.financialProfileStore.setSuperAnnuationProvider(value)
    }

    handleFundNameManuallyChange = e => {  

        this.props.financialProfileStore.setFundNameManuallyChange(e.target.value)
    }

    handleSuperProductNameManuallyChange = e => {
        this.props.financialProfileStore.setProductNameManuallyChange(e.target.value)
    }

    handleSuperABNManuallyChange = e => {
        const onlyNums = e.target.value.replace(/\D/g, "");
        this.props.financialProfileStore.setSuperABNManuallyChange(onlyNums);
    };

    handleSuperUSIManuallyChange = e => {
        this.props.financialProfileStore.setSuperUSIManuallyChange(e.target.value)
    }

    handleEsaAliasChange = e => {
        this.props.financialProfileStore.setEsaAlias(e.target.value)
    }

    handleSuperBankAccountNameChange = e => {
        this.props.financialProfileStore.setSuperBankAccountName(e.target.value)
    }


    handleSuperBsbChange = e => {
        const onlyNums = e.target.value.replace(/\D/g, "");
        this.props.financialProfileStore.setSuperBsb(onlyNums);
    }

    handleSuperBankAccountNumberChange = e => {
        const onlyNums = e.target.value.replace(/\D/g, "");
        this.props.financialProfileStore.setSuperBankAccountNumber(onlyNums);
    }

    handleSuperProductNameChange = value => {
        this.props.financialProfileStore.setSuperAnnuationProviderProduct(value)
    }

    
    mapSuperAnnuationProvider = () => {
        const { superAnnuationProviderList } = this.props.financialProfileStore;
        
        // Use a Set to track unique ABNs
        const seenABNs = new Set();

        // 1. Filter the list to remove duplicates based only on ABN
        const uniqueProviders = superAnnuationProviderList.filter(act => {
            // Check if the ABN has already been seen
            if (seenABNs.has(act.aBN)) {
                return false; // Duplicate ABN, filter it out
            }
            
            // Not a duplicate ABN, add it to the Set and keep the item
            seenABNs.add(act.aBN);
            return true;
    });

    // 2. Map the filtered list to the required {value, label} format
    return uniqueProviders.map(act => {
        return {
            value: act.aBN,
            label: act.fundName
        };
    });
};

    mapSuperAnnuationProviderProduct = () => {
        const { superAnnuationProviderList } = this.props.financialProfileStore;
        return superAnnuationProviderList.map(act => {
            return {
                value: act.uSI,
                label: act.productName
            };
        });
    };


      validateTaxFileNumber = (value) => {
        const cleanedValue = value.trim(); // Remove leading/trailing spaces for validation

        if (cleanedValue === "") {
            this.setState({
                taxFileNumberError: false, // Or true if empty is an error
                taxFileNumberHelperText: '', // Or "Tax File Number is required"
            });
            return false;
        }

        // Regular expression to check for 8 or 9 digits
        const regex = /^\d{8,9}$/; // ^ start of string, \d any digit, {8,9} exactly 8 or 9 times, $ end of string

        if (!regex.test(cleanedValue)) {
            this.setState({
                taxFileNumberError: true,
                taxFileNumberHelperText: "Must be 8 or 9 digits only",
            });
            return false;xw1x``
        } else {
            this.setState({
                taxFileNumberError: false,
                taxFileNumberHelperText: '',
            });
            return true;
        }
    };

     handleEditSaveClick = () => {
        const {taxFileNumber} = this.props.financialProfileStore.superAnnuationProfile

        if (this.state.isTaxEditable) {
            // Currently in "Edit" mode, so clicking means "Save"
            const isValid = this.validateTaxFileNumber(taxFileNumber);

            if (isValid) {
                // Dispatch action or call API to save the new taxFileNumber
                this.setState({ isTaxEditable: false });
                this.props.financialProfileStore.saveTaxFileNumber().then(() => {
                    this.props.templateStore.openSnackbar("Tax file number saved");
                })
            } else {
                // If not valid, keep in edit mode and show error
                console.log("Validation failed, not saving.");
            }
        } else {
            // Currently in "View" mode, so clicking means "Edit"
            this.setState({ isTaxEditable: true });
        }
    };

    handleClickCustomProvider = e => {
        e.preventDefault()
       this.props.financialProfileStore.handleCustomProvider()
    }

    handleBirthDate = date => {
        this.props.financialProfileStore.setBirthDate(date)
    };
    handleFirstName = e => {
        this.props.financialProfileStore.setFirstName(e.target.value)
    };
    handleLastName = e => {
        this.props.financialProfileStore.setLastName(e.target.value)
    };
    handleTaxFileNumber = e => {
        const inputValue = e.target.value;

    const numericValue = inputValue.replace(/\D/g, '');

        this.props.financialProfileStore.setTaxFileNumber(numericValue)
    };
    handleBankNameChange = e => this.props.financialProfileStore.setBankName(e.target.value);
    handleBsbNumberChange = e => this.props.financialProfileStore.setBsbNumber(e.target.value)
    handleAccountNumberChange = e => {
        this.props.financialProfileStore.setAccountNumber(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }
    handleAccountDescriptionChange = e => this.props.financialProfileStore.setAccountDescription(e.target.value);
    // handleAbnChange = e => {
    //     this.props.financialProfileStore.setAbn(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    // }

    handleAbn1Change = e => {
        this.props.financialProfileStore.setAbn1(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }

    handleAbn2Change = e => {
        this.props.financialProfileStore.setAbn2(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }

    handleAbn3Change = e => {
        this.props.financialProfileStore.setAbn3(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }

    handleAbn4Change = e => {
        this.props.financialProfileStore.setAbn4(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }
    handleAbnChange = e => {
        this.props.financialProfileStore.setAbn(e.target.value.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.'))
    }
    
    handleCurrencyChange = e => {
        this.props.financialProfileStore.setCurrency(e.target.value);
    };
  
    handleToggleHideVenueAgencyFees  = () => {
        this.props.financialProfileStore.handleToggleHideVenueAgencyFees();
    };
    handleToggleHideActFees  = () => {
        this.props.financialProfileStore.handleToggleHideActFees();
    };
    handleToggleHideArtistAgencyFees  = () => {
        this.props.financialProfileStore.handleToggleHideArtistAgencyFees();
    };

    handleToggleHideVenueFees = () => {
        this.props.financialProfileStore.handleToggleHideVenueFees();
    };

    handleToggleIncomingAddress  = () => {
        this.props.financialProfileStore.setIncomingToggleAddress();
    };


    handleToggleOutgoingAddress = () => {
        this.props.financialProfileStore.setOutgoingToggleAddress();
    };
    

    handleAutoSendTimeChange = e => {
        this.props.financialProfileStore.setAutoSendTime(e);
    };
    handleAutoSendDay = e => {
        this.props.financialProfileStore.setAutoSendDay(e.target.value);
    };
    handleAutoSendChange = e => {
        this.props.financialProfileStore.setAutoSend();
        this.setState({ dialogAutoSendPopUp: false, dialogAutoSendOffPopUp: false });
    };

    
    handleStreetChangeIncoming = e => this.props.financialProfileStore.setStreetIncoming(e.target.value);
    handleCityChangeIncoming = e => this.props.financialProfileStore.setCityIncoming(e.target.value);
    handlePostalChangeIncoming = e => this.props.financialProfileStore.setPostalIncoming(e.target.value);
    handleStateChangeIncoming = e => this.props.financialProfileStore.setStateIncoming(e.target.value);
    handleCountryChangeIncoming = value => this.props.financialProfileStore.setCountryCodeIncoming(value);
    handleChangeLongitudeLatitudeIncoming = value => {
        this.props.financialProfileStore.setLongitudeLatitudeIncoming(value);
    };
    handleChangeSearchAddressIncoming = value => {
        this.props.financialProfileStore.setSearchedAddressIncoming(value);
    };

    handleStreetChangeOutgoing = e => this.props.financialProfileStore.setStreetOutgoing(e.target.value);
    handleCityChangeOutgoing = e => this.props.financialProfileStore.setCityOutgoing(e.target.value);
    handlePostalChangeOutgoing = e => this.props.financialProfileStore.setPostalOutgoing(e.target.value);
    handleStateChangeOutgoing = e => this.props.financialProfileStore.setStateOutgoing(e.target.value);
    handleCountryChangeOutgoing = value => this.props.financialProfileStore.setCountryCodeOutgoing(value);
    handleChangeLongitudeLatitudeOutgoing = value => {
        this.props.financialProfileStore.setLongitudeLatitudeOutgoing(value);
    };
    handleChangeSearchAddressOutgoing = value => {
        this.props.financialProfileStore.setSearchedAddressOutgoing(value);
    };

    openDialogAutoSendPopUp = () => {
        const {autoSend} = this.props.financialProfileStore
        if(autoSend){
            this.setState({ dialogAutoSendOffPopUp: true });
        }else{
            this.handleAutoSendChange()
        }
        
        
    }

    closeDialogAutoSendPopUp = () => {
        this.setState({ dialogAutoSendPopUp: false });
    }

    closeDialogAutoSendOffPopUp = () => {
        this.setState({ dialogAutoSendOffPopUp: false });
    }

    handleTaxChange = e => {
        this.props.financialProfileStore.setTax(e.target.value);

        switch (e.target.value) {
            case "GST":
                this.props.financialProfileStore.setTaxValue(10);
                break;
            case "GSTNZ":
                this.props.financialProfileStore.setTaxValue(15);
                break;
            case "VAT":
                this.props.financialProfileStore.setTaxValue(20);
                break;
            case "NOT":
                this.props.financialProfileStore.setTaxValue(0);
                break;
            default:
                break;
        }
    };
    getBsbLabel = () => {
        const {currency} = this.props.financialProfileStore;
        var label = "BSB"

        if(currency === "GBP"){
            label = "Sort Code"
        }else if(currency === "NZD"){
            label = "Bank Code"
        }else if(currency === "USD"){
            label = "Routing Number"}
        return label
    }
    getABNLabel = () => {
        const {currency} = this.props.financialProfileStore;
        var label = "ABN"

        if(currency === "GBP"){
            label = "VRN"
        }else if(currency === "NZD"){
            label = "NZBN"
        }else if(currency === "USD"){
            label = "EIN"}
        return label
    }
    getTaxOptions = () => {
        const {currency} = this.props.financialProfileStore;
        var taxOptions = []
        if(currency === "AUD"){
            taxOptions = [{value:"GST",label:"GST (10%)"}, {value:"NOT",label:"Not Applicable (0%)"}]
            
        }else if(currency === "NZD"){
            taxOptions = [{value:"GSTNZ",label:"GST-NZ (15%)"}, {value:"NOT",label:"Not Applicable (0%)"}]
        }else if(currency === "GBP"){
            taxOptions = [{value:"VAT",label:"VAT (20%)"}, {value:"NOT",label:"Not Applicable (0%)"}]

        }else if(currency === "USD"){
            taxOptions = [{value:"CUSTOM",label:"Custom Tax Percentage"}, {value:"NOT",label:"Not Applicable (0%)"}]

        }else{
            taxOptions = [{value:"GST",label:"GST (10%)"},{value:"GSTNZ",label:"GST-NZ (15%)"}, {value:"VAT",label:"VAT (20%)"},{value:"CUSTOM",label:"Custom Tax Percentage"}, {value:"NOT",label:"Not Applicable (0%)"}]
        }
        return taxOptions.map((item) => (
            <MenuItem key={item.value} value={item.value}>
                {item.label}
            </MenuItem>
        ));
        
    }
    handleTaxValueChange = e => this.props.financialProfileStore.setTaxValue(e.target.value);
    handlePaymentTermsChange = e => this.props.financialProfileStore.setPaymentTerms(e.target.value);
    handleOutgoingPaymentTermsChange = e => this.props.financialProfileStore.setOutgoingPaymentTerms(e.target.value);
    handlePaymentOptionsChange = e => this.props.financialProfileStore.setPaymentOptions(e.target.value);
    handlePushNotificationChange = e => this.props.financialProfileStore.setPushNotification(e.target.checked);
    handleEmailNotificationChange = e => this.props.financialProfileStore.setEmailNotification(e.target.checked);

    setIncomingInvoiceAddress = e => this.props.financialProfileStore.setIncomingInvoiceAddress(e.target.value);
    setIncomingInvoiceEmail = e => this.props.financialProfileStore.setIncomingInvoiceEmail(e.target.value);
    setIncomingEntityName = e => this.props.financialProfileStore.setIncomingEntityName(e.target.value);
    setOutgoingEntityName = e => this.props.financialProfileStore.setOutgoingEntityName(e.target.value);
    setOutgoingInvoiceEmail = e => this.props.financialProfileStore.setOutgoingInvoiceEmail(e.target.value);
    setOutgoingInvoiceAddress = e => this.props.financialProfileStore.setOutgoingInvoiceAddress(e.target.value);

    handleNextInvoiceNumberChange = e => this.props.financialProfileStore.setNextInvoiceNumber(e.target.value);
    handleMonthlyBudgetChange = e => this.props.financialProfileStore.setMonthlyBudget(e.target.value);
    handleCCInvoiceEmailChange = e => this.props.financialProfileStore.setcCInvoiceEmailAddress(e.target.value);
    validateCCInvoiceEmail = e => this.props.financialProfileStore.validateCCInvoiceEmail(e.target.value);

    // handleInsuranceNameChange = e => this.props.financialProfileStore.setInsuranceName(e.target.value);
    // handleInsuranceCompanyChange = e => this.props.financialProfileStore.setInsuranceCompany(e.target.value);
    // handlePolicyNumberChange = e => this.props.financialProfileStore.setPolicyNumber(e.target.value);
    // handleDateStartChange= e => this.props.financialProfileStore.setDateStart(e.target.value);

    handlemonthlyBudgetTypeChange = e => {
        this.props.financialProfileStore.setMonthlyBudgetType(e.target.checked);
    };

    handleEachMonthChange = e => {
        this.props.financialProfileStore.setEachMonthlyBudgetType(e.target.id, e.target.value);
    };


    handleBack = () => {
        if (this.props.type === "venue") {
            const { profile } = this.props.profileStore;
            this.props.history.push(`/venues/${profile.id}/edit/design`);
        }
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    // handleChangelegalEntity = value => {
    //     if(value === LegalEntityType.SoleTrader.ordinal || this.props.financialProfileStore.legalEntity === LegalEntityType.SoleTrader.ordinal)
    //     this.setState({
    //         legalEntityChange: true
    //     })
    //     this.props.financialProfileStore.setlegalEntity(value);
       
    // };

    handleChangeUSI = e => {
        this.props.financialProfileStore.setUSI(e.target.value);
    };

    handleChangememberNumberSuper = e => {
        this.props.financialProfileStore.setmemberNumberSuper(e.target.value);
    };

    handleChangeNoFundYet = value => {
        this.props.financialProfileStore.setNoFundYet();
    };
    handleSubmit = e => {
        e.preventDefault()
        if(this.state.legalEntityChange){
            this.setState({
                openConfirmationDialog: true
            })
        }else{
            this.handleSubmitForm(e)
        }

    }
    closeConfirmDialog = () => {
         this.setState({
                openConfirmationDialog: false
            })
    }

    handleSubmitForm = e => {
        e.preventDefault();
        this.setState({ isLoading: true });
        const { profile } = this.props.profileStore;
        this.props.financialProfileStore.submit().then(async resp => {
            this.props.profileStore.setProfilePaymentType(this.props.financialProfileStore.paymentType);
            this.props.profileStore.setProfileSuperPaymentMethod(this.props.financialProfileStore.superPaymentMethod);
            if (this.props.type === "venue") {
                this.props.history.push(`/venues/${resp.id}/edit/social`);
            }
            if(profile.isCompleted){
                await this.props.profileStore.loadProfiles().then(() => {
                    const { editProfileActiveStep } = this.props.templateStore;
                    this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
                })
            }else{
                const { editProfileActiveStep } = this.props.templateStore;
                this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
            }
        }).catch(error => {
            if (error.response && error.response.status === 403) {
                this.props.templateStore.openSnackbar(error.response.data.errors);
            } else if(error?.isError){
                this.props.templateStore.openSnackbar(error.message);
            }else {
                console.error("An unexpected error occurred:", error);
            }
        }).finally(() => {
            this.setState({ isLoading: false, openConfirmationDialog: false });
        });
    };

    abnError = () => {
        const store = this.props.financialProfileStore;
        const splitAbn = `${this.state.abn1 || ""}${this.state.abn2 || ""}${this.state.abn3 || ""}${this.state.abn4 || ""}`;

        // Australian saves use the four editable parts, not the original loaded ABN.
        const rawInput = store?.currency === "AUD"
            ? [store.abn1, store.abn2, store.abn3, store.abn4].map(part => part || "").join("")
            : this.state.abn || splitAbn || store?.abn || "";
        if (store?.currency === "AUD" && !rawInput) return "";
        const raw = String(rawInput).replace(/\D/g, "");

        if (!raw) return "ABN is required";
        if (raw.length !== 11) return "ABN must be exactly 11 digits";

        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        const digits = raw.split("").map(Number);
        digits[0] -= 1;

        const sum = digits.reduce((acc, d, i) => acc + d * weights[i], 0);
        if (sum % 89 !== 0) return "ABN is invalid";

        return "";
    };

    superAbnError = () => {
        const store = this.props.financialProfileStore;
        const rawInput = store?.superAnnuationProfile?.aBN || this.state.superABN || "";
        const formatError = superAbnFormatError(rawInput);
        if (formatError) return formatError;
        const raw = String(rawInput).replace(/\D/g, "");

        if (!raw) return "";
        if (raw.length !== 11) return "ABN must be exactly 11 digits";

        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        const digits = raw.split("").map(Number);
        digits[0] -= 1;

        const sum = digits.reduce((acc, d, i) => acc + d * weights[i], 0);
        if (sum % 89 !== 0) return "ABN is invalid";

        return "";
    };

    anyError(field) {
        if (field === "bsb" && superBsbFormatError(this.props.financialProfileStore.superAnnuationProfile.bsb)) {
            return true;
        }
        if (field === "abn") {
            const hasAbnError = !!this.abnError();
            if (hasAbnError) return true;
        }

        if (field === "superABN") {
            const hasSuperAbnError = !!this.superAbnError();
            if (hasSuperAbnError) return true;
        }

        if (!this.props.financialProfileStore.errors) return false;
        if (!this.props.financialProfileStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (field === "bsb") {
            const formatError = superBsbFormatError(this.props.financialProfileStore.superAnnuationProfile.bsb);
            if (formatError) return formatError;
        }
        if (field === "abn") {
            const abnErrMessage = this.abnError();
            if (abnErrMessage) return abnErrMessage;
        }

        if (field === "superABN") {
            const superAbnErrMessage = this.superAbnError();
            if (superAbnErrMessage) return superAbnErrMessage;
        }

        if (!this.props.financialProfileStore.errors) return null;
        if (!this.props.financialProfileStore.errors[field]) return null;
        return this.props.financialProfileStore.errors[field];
    }

    hasLeadingSpace = (value) => {
        return typeof value === "string" && value.startsWith(" ");
    };

    render() {
        const {
            bankName,
            bsbNumber,
            accountNumber,
            accountDescription,
            abn,
            abn1,
            abn2,
            abn3,
            abn4,
            currency,
            tax,
            taxValue,
            monthlyBudget,
            paymentTerms,
            outgoingPaymentTerms,
            monthlyBudgetType,
            paymentOptions,
            nextInvoiceNumber,
            cCInvoiceEmailAddress,
            januaryBudget,
            februaryBudget,
            marchBudget,
            aprilBudget,
            mayBudget,
            juneBudget,
            julyBudget,
            augustBudget,
            septemberBudget,
            octoberBudget,
            novemberBudget,
            decemberBudget,
            autoSend, 
            autoSendDay, 
            autoSendTime,
            incomingToggleAddress,
            outgoingToggleAddress,
            searchedAddressIncoming, 
            incomingInvoiceEmail, 
            incomingEntityName, 
            outgoingEntityName,
            outgoingInvoiceEmail,
            searchedAddressOutgoing,
            streetIncoming,
            cityIncoming,
            postalIncoming,
            stateIncoming,
            countryCodeIncoming,
            longitudeIncoming,
            latitudeIncoming,
            streetOutgoing,
            cityOutgoing,
            postalOutgoing,
            stateOutgoing,
            countryCodeOutgoing,
            longitudeOutgoing,
            latitudeOutgoing,
            hideVenueAgencyFees, hideActFees, hideArtistAgencyFees, hideVenueFees,
            // insuranceName,
            // insuranceCompany,
            // policyNumber,
            // insuranceExpiryDate
            uSI,
            legalEntity,
            memberNumberSuper,
            noFundYet,
            superAnnuationProfile,
            isCustom
        } = this.props.financialProfileStore;
        const { editProfileActiveStep } = this.props.templateStore;
        const type = this.props.type;
        const steps = this.props.templateStore.getSteps(type);
        const { isLoading,isTaxEditable } = this.state;
        const { currentProfile, profile } = this.props.profileStore;
        const isStaff = currentProfile && currentProfile.type === ProfileType.Staff.ordinal;
        const isMusician = currentProfile && currentProfile.type === ProfileType.Musician.ordinal;
        const isAgent = currentProfile && currentProfile.type === ProfileType.Agent.ordinal;
        let legalEntitySuggestion = () => {
            return [
                {
                    value: 0,
                    label: "Not Set"
                },
                {
                    value: 1,
                    label: "Sole Trader"
                },
                {
                    value: 2,
                    label: "Partnership"
                },
                {
                    value: 3,
                    label: "Company"
                },
                {
                    value: 4,
                    label: "Trust"
                },
                {
                    value: 5,
                    label: "Hobbyist"
                }
            ]
        };
        let countriesSuggestion = () => {
            return Countries.map(country => {
                return {
                    value: country.code,
                    label: country.name,
                    divider: country.divider
                };
            });
        };
        return (
            <div className="Profile-Financial">
                <form onSubmit={this.handleSubmit} className="form-relative">
                    <Loading showed={isLoading} />
                    <Grid container spacing={24}>
                        <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Financial"
                                helpText={type === "venue" 
                                    ? "In this section you are able to choose how your invoices coming from musicians, acts and agents will be batched. For example, if you choose 14 day batching, all the gigs that have been booked and performed within the 14 day period will arrive on the same day at the end of the batching cycle. If the same act has performed more than once within that batching period, their gigs will appear in line format with all details on just 1 invoice. Hit the drop down and choose your batching preference."
                                    : "This information will be used to create invoices within Hot Giggity. We will never sell, rent, or share your personal information with any third parties. If you are migrating from another invoicing program, set the 'Next invoice number' to follow on from the last invoice in your previous program."
                                }
                            />
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="currency"
                                        label="Currency"
                                        select
                                        margin="dense"
                                        fullWidth
                                        value={currency}
                                        onChange={this.handleCurrencyChange}
                                        error={this.anyError("currency")}
                                        helperText={this.errorText("currency")}
                                    >
                                        <MenuItem value="AUD">AUD</MenuItem>
                                        <MenuItem value="USD">USD</MenuItem>
                                        <MenuItem value="GBP">GBP</MenuItem>
                                        <MenuItem value="NZD">NZD</MenuItem>
                                    </TextField>
                                </Grid>
                              
                            <Grid item xs={12} md={6}>
                            {type === "venue" && (
                                        <TextField
                                            id="cCInvoiceEmailAddress"
                                            label="Accounts Email Address"
                                            margin="dense"
                                            fullWidth
                                            value={cCInvoiceEmailAddress}
                                            onChange={this.handleCCInvoiceEmailChange}
                                            onBlur={this.validateCCInvoiceEmail}
                                            error={this.anyError("cCInvoiceEmailAddress")}
                                            helperText={this.errorText("cCInvoiceEmailAddress")}
                                        />)}
                               
                                    {type !== 'venue' && 
                                        <TextField
                                            id="tax"
                                            label="Tax"
                                            select
                                            margin="dense"
                                            fullWidth
                                            value={tax}
                                            onChange={this.handleTaxChange}
                                            error={this.anyError("tax")}
                                            helperText={this.errorText("tax")}
                                        >
                                            {this.getTaxOptions()}
                                            {/* <MenuItem value="GST">GST (10%)</MenuItem>
                                            <MenuItem value="GSTNZ">GST-NZ (15%)</MenuItem>
                                            <MenuItem value="VAT">VAT (20%)</MenuItem>
                                            <MenuItem value="NOT">Not Applicable (0%)</MenuItem>
                                            <MenuItem value="CUSTOM">Custom Tax Percentage</MenuItem> */}
                                        </TextField>
                                }
                            
                            </Grid>
                            <Grid container spacing={8}>
                            </Grid>
                                   {type !== 'venue' && 
                                    tax === "CUSTOM" && (
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="taxValue"
                                                label="Tax Value (%)"
                                                margin="dense"
                                                fullWidth
                                                value={Number(taxValue)}
                                                onChange={this.handleTaxValueChange}
                                                error={this.anyError("taxValue")}
                                                helperText={this.errorText("taxValue")}
                                                type="number"
                                            />
                                        </Grid>
                                    )
                                }
                            
                             {  currency === "AUD" && type !== 'venue' ?
                                <Fragment>
                                    <Grid item xs={3} md={1}>
                                        <TextField
                                            id="abn"
                                            label={this.getABNLabel()}
                                            margin="dense"
                                            fullWidth
                                            value={abn1}
                                            onChange={this.handleAbn1Change}
                                            error={this.anyError("abn")}
                                            helperText={this.errorText("abn")}
                                            type="text"
                                            inputProps={{ maxLength: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3} md={1}>
                                        <TextField
                                            id="abn"
                                            label=" "
                                            margin="dense"
                                            fullWidth
                                            value={abn2}
                                            onChange={this.handleAbn2Change}
                                            error={this.anyError("abn")}
                                            helperText={this.errorText("abn")}
                                            type="text"
                                            inputProps={{ maxLength: 3 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3} md={1}>
                                        <TextField
                                            id="abn"
                                            label=" "
                                            margin="dense"
                                            fullWidth
                                            value={abn3}
                                            onChange={this.handleAbn3Change}
                                            error={this.anyError("abn")}
                                            helperText={this.errorText("abn")}
                                            type="text"
                                            inputProps={{ maxLength: 3 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3} md={1}>
                                        <TextField
                                            id="abn"
                                            label=" "
                                            margin="dense"
                                            fullWidth
                                            value={abn4}
                                            onChange={this.handleAbn4Change}
                                            error={this.anyError("abn")}
                                            helperText={this.errorText("abn")}
                                            type="text"
                                            inputProps={{ maxLength: 3 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        
                                    </Grid>
                                </Fragment> :
                                null
                            }
                             {  currency != "AUD" && type !== 'venue' ?
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="abn"
                                        label={this.getABNLabel()}
                                        margin="dense"
                                        fullWidth
                                        value={abn}
                                        onChange={this.handleAbnChange}
                                        error={this.anyError("abn")}
                                        helperText={this.errorText("abn")}
                                        type="text"
                                    />
                                </Grid> : null
                                
                            }
                            </Grid>
                            <Grid container spacing={8}>
                                {type !== 'venue' && 
                                <Fragment>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="bankName"
                                            label="Bank Account Name"
                                            margin="dense"
                                            fullWidth
                                            value={bankName}
                                            onChange={this.handleBankNameChange}
                                            error={this.anyError("bankName")}
                                            helperText={this.errorText("bankName")}
                                        />
                                    </Grid>
    
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="bsbNumber"
                                            label={this.getBsbLabel()}
                                            margin="dense"
                                            fullWidth
                                            value={bsbNumber}
                                            onChange={this.handleBsbNumberChange}
                                            error={this.anyError("bsbNumber")}
                                            helperText={this.errorText("bsbNumber")}
                                            type="text"
                                        />
                                    </Grid>
    
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="accountNumber"
                                            label="Account Number"
                                            margin="dense"
                                            fullWidth
                                            value={accountNumber}
                                            onChange={this.handleAccountNumberChange}
                                            error={this.anyError("accountNumber")}
                                            helperText={this.errorText("accountNumber")}
                                            type="text" 
                                        />
                                    </Grid>
    
                                    {/* <Grid item xs={12}>
                                        <TextField
                                            id="accountDescription"
                                            label="Description"
                                            margin="dense"
                                            fullWidth
                                            value={accountDescription}
                                            onChange={this.handleAccountDescriptionChange}
                                            error={this.anyError("accountDescription")}
                                            helperText={this.errorText("accountDescription")}
                                        />
                                    </Grid> */}
                                   
                                    
                                </Fragment>
                                }

             

                               
                               { type === 'venue' &&
                                    <Fragment>
                                        <Grid item xs={12} md={12}>
                                            <Grid item xs={12} md={5}>
                                                <Switch checked={autoSend} onChange={this.openDialogAutoSendPopUp} value="hideToolbar" /> Automatically send to accounts
                                            </Grid>
                                        </Grid>
                                        {
                                            autoSend ?
                                            <Fragment>
                                                <Grid item xs={12} md={6}>
                                                <TextField
                                                    id="autoSendDay"
                                                    label="Auto Send Day"
                                                    select
                                                    margin="dense"
                                                    fullWidth
                                                    value={autoSendDay}
                                                    onChange={this.handleAutoSendDay}
                                                    error={this.anyError("autoSendDay")}
                                                    helperText={this.errorText("autoSendDay") || "Last week's invoices (Mon-Sun) will be sent to accounts on this day."}
                                                >
                                                    <MenuItem value="Monday">Monday</MenuItem>
                                                    <MenuItem value="Tuesday">Tuesday</MenuItem>
                                                    <MenuItem value="Wednesday">Wednesday</MenuItem>
                                                    <MenuItem value="Thursday">Thursday</MenuItem>
                                                    <MenuItem value="Friday">Friday</MenuItem>
                                                    <MenuItem value="Saturday">Saturday</MenuItem>
                                                    <MenuItem value="Sunday">Sunday</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <div style={{paddingTop:8}}>
                                                <HubTimepicker2
                                                    margin="dense"
                                                    label="Auto Send Time"
                                                    value={moment(autoSendTime, "HH:mm")}
                                                    onChange={this.handleAutoSendTimeChange}
                                                    error={this.errorText["autoSendTime"]}
                                                    helperText={this.errorText["autoSendTime"]}
                                                />
                                                </div>
                                            </Grid>
                                            </Fragment> : null
                                        }
                                    </Fragment>
                               }
                               
                                
                              

                              

                               
                                
                                
                               

                                {isStaff && !monthlyBudgetType && type === 'venue' && (
                                    <Grid container>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="monthlyBudget"
                                            label="Monthly Budget"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={monthlyBudget}
                                            onChange={this.handleMonthlyBudgetChange}
                                            error={this.anyError("monthlyBudget")}
                                            helperText={this.errorText("monthlyBudget")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <div style={{ paddingTop: 20 }} >
                                            <Switch
                                                checked={monthlyBudgetType}
                                                onChange={this.handlemonthlyBudgetTypeChange}
                                                value="monthlyBudgetType"
                                                color="primary"
                                                id="BudgetType"
                                                className="BudgetType"
                                            />
                                            Set Your Budget For Each Month
                                        </div>
                                    </Grid>
                                    </Grid>
                                    
                                )}

                                
                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} md={12}>
                                        <div>
                                            <Switch
                                                checked={monthlyBudgetType}
                                                onChange={this.handlemonthlyBudgetTypeChange}
                                                value="monthlyBudgetType"
                                                color="primary"
                                                id="BudgetType"
                                                className="BudgetType"
                                            />
                                            Set Your Budget For Each Month
                                        </div>
                                    </Grid>
                                )}
                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="January"
                                            label="January"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={januaryBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("januaryBudget")}
                                            helperText={this.errorText("januaryBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="February"
                                            label="February"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={februaryBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("februaryBudget")}
                                            helperText={this.errorText("februaryBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="March"
                                            label="March"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={marchBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("marchBudget")}
                                            helperText={this.errorText("marchBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="April"
                                            label="April"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={aprilBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("aprilBudget")}
                                            helperText={this.errorText("aprilBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="May"
                                            label="May"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={mayBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("mayBudget")}
                                            helperText={this.errorText("mayBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="June"
                                            label="June"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={juneBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("juneBudget")}
                                            helperText={this.errorText("juneBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="July"
                                            label="July"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={julyBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("julyBudget")}
                                            helperText={this.errorText("julyBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="August"
                                            label="August"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={augustBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("augustBudget")}
                                            helperText={this.errorText("augustBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="September"
                                            label="September"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={septemberBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("septemberBudget")}
                                            helperText={this.errorText("septemberBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="October"
                                            label="October"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={octoberBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("octoberBudget")}
                                            helperText={this.errorText("octoberBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="November"
                                            label="November"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={novemberBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("novemberBudget")}
                                            helperText={this.errorText("novemberBudget")}
                                        />
                                    </Grid>
                                )}

                                {isStaff && monthlyBudgetType && (
                                    <Grid item xs={12} lg={2} md={4}>
                                        <TextField
                                            id="December"
                                            label="December"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            value={decemberBudget}
                                            onChange={this.handleEachMonthChange}
                                            error={this.anyError("decemberBudget")}
                                            helperText={this.errorText("decemberBudget")}
                                        />
                                    </Grid>
                                )}

                                
                               
                            </Grid>
                        </Grid>


                          {(type === "musician" || type === "agent") && legalEntityHasSuper(legalEntity) && (!currency || currency === "AUD") ? 
                        <Fragment>
                            <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Superannuation"
                                helpText="Add your superannuation details here. All users must set their legal entity. Sole traders must also add all super fund details."
                            />
                            <Grid container spacing={8}>                
                                <Grid item xs={12} md={6}>
                                    <SelectField
                                        id="actTypeId"
                                        multi={false}
                                        suggestions={legalEntityHasSuper(legalEntity) ? legalEntitySuggestionsWithSuper : legalEntitySuggestions}
                                        onChange={this.handleChangelegalEntity}
                                        value={legalEntity}
                                        placeholder=" "
                                        label="Legal Entity*"
                                        margin="dense"
                                        error={this.anyError("legalEntity")}
                                        helperText={this.errorText("legalEntity")}
                                    />
                                </Grid>
                                 <Grid item xs={12} md={6}>
                                    {/* <div style={{marginTop:20}}>
                                     <Switch checked={noFundYet} onChange={this.handleChangeNoFundYet} value="noFundYet" color="primary" />{" "}
                                                No Fund Yet
                                                </div> */}
                                </Grid>
                                 <Grid item xs={12} md={6}>
                                    <TextField
                                        id="superFirstName"
                                        label="First Name*"
                                        margin="dense"
                                        fullWidth
                                        value={superAnnuationProfile?.firstName}
                                        onChange={this.handleFirstName}
                                        error={this.anyError("superFirstname")}
                                        helperText={this.errorText("superFirstname")}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="superLastName"
                                        label="Last Name*"
                                        margin="dense"
                                        fullWidth
                                        value={superAnnuationProfile?.lastName}
                                        onChange={this.handleLastName}
                                        error={this.anyError("superLastName")}
                                        helperText={this.errorText("superLastName")}
                                    />
                                </Grid>
                               
                                <Grid item xs={12} md={6}>
                                    <SimpleDatePicker
                                        id="superBirthDate"
                                        value={superAnnuationProfile?.birthDate}
                                        fullWidth
                                        margin="dense"
                                        onChange={this.handleBirthDate}
                                        label="Date of Birth*"
                                        error={this.anyError("birthDate")}
                                        helperText={this.errorText("birthDate")}
                                    />
                                </Grid>
                                    <Grid item xs={10} md={5}> {/* Adjust grid size to make space for the button */}
                                        <TextField
                                            id="taxFileNumber"
                                            label="Tax File Number*"
                                            margin="dense"
                                            fullWidth
                                            value={isTaxEditable ? superAnnuationProfile?.taxFileNumber : superAnnuationProfile?.taxFileNumber && superAnnuationProfile?.taxFileNumber.length > 3 ? `***** ${superAnnuationProfile?.taxFileNumber.toString().substr(superAnnuationProfile?.taxFileNumber.length - 3)}` : ""}
                                            onChange={this.handleTaxFileNumber}
                                            error={this.state.taxFileNumberError}
                                            helperText={this.state.taxFileNumberHelperText}
                                            disabled={!isTaxEditable}
                                            inputProps={{
                                                inputMode: 'numeric', // Shows numeric keyboard on mobile
                                                pattern: '[0-9]*', // Hint for browsers, regex does the actual validation
                                                maxLength: 9 // HTML maxLength to prevent typing beyond 9 characters
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2} md={1} style={{marginTop:25}}> {/* Grid item for the button */}
                                        <Button
                                            variant="contained" // Or "outlined" or "text"
                                            onClick={this.handleEditSaveClick}
                                            fullWidth // Makes the button take full width of its grid item
                                        >
                                            {isTaxEditable ? "Save" : "Edit"}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Button
                                            color="primary"
                                            variant="contained" // Changed from "contained" to "text"
                                            onClick={this.handleClickCustomProvider}
                                            // fullWidth // Removed fullWidth as it's usually not desired for text buttons
                                        >
                                            {isCustom ? 'Use Existing Listed Fund Name' : `Add custom super provider setting`}
                                        </Button>
                                    </Grid>
                                {
                                    isCustom ? <Fragment key="custom">
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="customFundName"
                                                label="Fund Name*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.fundName}
                                                onChange={this.handleFundNameManuallyChange}
                                                error={this.anyError("fundName")}
                                                helperText={this.errorText("fundName")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="customSuperABN"
                                                label={legalEntityIsSoleTrader(legalEntity) ? "Super ABN*" : "Super ABN"}
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.aBN}
                                                onChange={this.handleSuperABNManuallyChange}
                                                error={this.anyError("superABN")}
                                                helperText={this.errorText("superABN")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="esaAlias"
                                                label="ESA Alias*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.esaAlias}
                                                onChange={this.handleEsaAliasChange}
                                                error={this.anyError("esaAlias")}
                                                helperText={this.errorText("esaAlias")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="superBankAccountName"
                                                label="Bank Account Name*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.bankAccountName}
                                                onChange={this.handleSuperBankAccountNameChange}
                                                error={this.anyError("bankAccountName")}
                                                helperText={this.errorText("bankAccountName")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="superBsb"
                                                label="BSB*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.bsb}
                                                onChange={this.handleSuperBsbChange}
                                                error={this.anyError("bsb")}
                                                helperText={this.errorText("bsb")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="superBankAccountNumber"
                                                label="Bank Account Number*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.bankAccountNumber}
                                                onChange={this.handleSuperBankAccountNumberChange}
                                                error={this.anyError("bankAccountNumber")}
                                                helperText={this.errorText("bankAccountNumber")}
                                            />
                                        </Grid>
                                    </Fragment> : 
                                    <Fragment key="standard">
                                        <Grid item xs={12} lg={6}>
                                            <SelectField
                                                id="superProvider"
                                                label="Product Name/Fund Name*"
                                                suggestions={this.mapSuperAnnuationProviderProduct()}
                                                onChange={this.handleSuperProductNameChange}
                                                value={superAnnuationProfile?.uSI}
                                                placeholder={"Select Super Provider"}
                                                emptyText="Super Provider on load"
                                                error={this.anyError("uSI")}
                                                helperText={this.errorText("uSI")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <SelectField
                                                id="superProvider"
                                                label="Parent Fund*"
                                                suggestions={this.mapSuperAnnuationProvider()}
                                                onChange={this.handleSuperProviderChange}
                                                value={superAnnuationProfile?.aBN}
                                                placeholder={"Select Super Provider"}
                                                emptyText="Super Provider on load"
                                                error={this.anyError("fundName")}
                                                helperText={this.errorText("fundName")}
                                            />
                                        </Grid>
                                        {
                                            superAnnuationProfile?.aBN ?  <Grid item xs={12} lg={6}>
                                                <TextField
                                                    id="superABN"
                                                    label="Super ABN*"
                                                    margin="dense"
                                                    fullWidth
                                                    value={superAnnuationProfile?.aBN }
                                                    disabled
                                                    error={this.anyError("superABN")}
                                                    helperText={this.errorText("superABN")}
                                                />
                                            </Grid> : <Grid item xs={12} lg={6}></Grid>
                                        }
                                        {
                                            superAnnuationProfile?.uSI ?  <Grid item xs={12} lg={6}>
                                                <TextField
                                                    id="USI"
                                                    label="USI*"
                                                    margin="dense"
                                                    fullWidth
                                                    value={superAnnuationProfile?.uSI }
                                                    disabled
                                                    error={this.anyError("uSI")}
                                                    helperText={this.errorText("uSI")}
                                                />
                                            </Grid> : <Grid item xs={12} lg={6}></Grid>
                                        }
                                        <Grid item xs={12} lg={6}>
                                            <TextField
                                                id="superFundMemberNumber"
                                                label="Super Fund Member Number*"
                                                margin="dense"
                                                fullWidth
                                                value={superAnnuationProfile?.superFundMemberNumber}
                                                onChange={this.handleSuperFundMemberNumber}
                                                error={
                                                    this.hasLeadingSpace(superAnnuationProfile?.superFundMemberNumber) ||
                                                    this.anyError("superFundMemberNumber")}
                                                helperText={
                                                    this.hasLeadingSpace(superAnnuationProfile?.superFundMemberNumber)
                                                    ? "There is a space at the start of the field."
                                                    : this.errorText("superFundMemberNumber")}
                                            />
                                        </Grid>
                                    </Fragment>
                                }
                            </Grid>
                                
                            </Grid>
                        </Fragment>
                       
                        : null}
                         {(type === "musician" || type === "agent") && !legalEntityHasSuper(legalEntity) && (!currency || currency === "AUD")? 
                        <Fragment>
                            <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Superannuation"
                                helpText="Add your superannuation details here. All users must set their legal entity. Sole traders must also add all super fund details."
                            />
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={6}>
                                    <SelectField
                                        id="actTypeId"
                                        multi={false}
                                        suggestions={legalEntitySuggestion()}
                                        onChange={this.handleChangelegalEntity}
                                        value={legalEntity}
                                        placeholder=" "
                                        label="Legal Entity*"
                                        margin="dense"
                                        error={this.anyError("legalEntity")}
                                        helperText={this.errorText("legalEntity")}
                                    />
                                </Grid>
                                 
                            </Grid>
                                
                            </Grid>
                        </Fragment>
                       
                        : null}

                        {(type === "agent" || type === "act" || type === "musician" || type === "venue") && (!currency || currency === "AUD") && (
                            <Grid item xs={12} lg={12}>
                                <SectionHeader
                                    title="Super Payments"
                                    helpText={
                                        type === "venue" ? "Choose how you want to pay superannuation contributions on behalf of your sole trader artists"
                                        : type === "act" ? "Choose how you want to pay superannuation contributions on behalf of your sole trader players"
                                        : type === "musician" ? "Choose how you want to pay superannuation contributions on behalf of your sole trader players"
                                        : "Choose how you want to pay superannuation contributions on behalf of your sole trader artists"
                                    }
                                />
                                <FormControl component="fieldset" style={{ marginBottom: 8 }}>
                                    <RadioGroup
                                        row
                                        value={this.props.financialProfileStore.superPaymentMethod}
                                        onChange={e => this.props.financialProfileStore.setSuperPaymentMethod(e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="xero"
                                            control={<Radio color="primary" />}
                                            label="Pay with XERO"
                                        />
                                        <FormControlLabel
                                            value="hgSuperPay"
                                            control={<Radio color="primary" />}
                                            label="Pay with HG Super Pay"
                                        />
                                    </RadioGroup>
                                </FormControl>

                                {this.props.financialProfileStore.superPaymentMethod === "xero" && (
                                    <div style={{
                                        padding: "14px 16px",
                                        marginBottom: 16,
                                        background: "#f9f9f9",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 8
                                    }}>
                                        <Typography variant="body2" style={{ color: "#555" }}>
                                            Click Next to save your choice. Once saved, activate Xero by upgrading to the Pro Plan (Manage / Account Settings / Membership) and then going to Pro Integrations to activate the Xero integration.
                                        </Typography>
                                    </div>
                                )}

                                {this.props.financialProfileStore.superPaymentMethod === "hgSuperPay" && (
                                    <div style={{
                                        padding: "14px 16px",
                                        marginBottom: 16,
                                        background: "#f9f9f9",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 8
                                    }}>
                                        <Typography variant="body2" style={{ color: "#555" }}>
                                            {type === "venue" ? (
                                                <>
                                                    Click Next to save your choice. Once saved, activate the add-on and complete your employer setup in the{" "}
                                                    <strong>HG Super Pay</strong> tab of this profile editor.
                                                </>
                                            ) : (
                                                <>
                                                    Click Next to save your choice. Once saved, activate the add-on and complete your employer setup in{" "}
                                                    <a href="/manage/hg-super-pay" style={{ color: "#fe0d9d" }}>Manage → HG Super Pay</a>.
                                                </>
                                            )}
                                        </Typography>
                                    </div>
                                )}
                            </Grid>
                        )}

                        {
                            type != "venue" &&
                            <Fragment>
                                <Grid item xs={12} lg={12}>
                                <SectionHeader
                                    title="Outgoing Invoices"
                                    helpText={type === "musician" ? musicianOutgoingInvoice : agencyOutgoingInvoice}
                                />
                                {type !== "venue" && (
                                    <Grid container spacing={8}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="outgoingPaymentTerms"
                                            label="Outgoing Invoices Payment Term"
                                            select
                                            margin="dense"
                                            fullWidth
                                            value={outgoingPaymentTerms}
                                            onChange={this.handleOutgoingPaymentTermsChange}
                                            error={this.anyError("outgoingPaymentTerms")}
                                            helperText={this.errorText("outgoingPaymentTerms") || "Outgoing invoices due date"}
                                        >
                                             <MenuItem value="0">Due on receipt</MenuItem>
                                             <MenuItem value="7">7 days</MenuItem>
                                             <MenuItem value="14">14 days</MenuItem>
                                             <MenuItem value="30">30 days</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                            <TextField
                                                id="paymentOptions"
                                                label="Payment Options"
                                                select
                                                margin="dense"
                                                fullWidth
                                                value={paymentOptions}
                                                onChange={this.handlePaymentOptionsChange}
                                                error={this.anyError("paymentOptions")}
                                                helperText={this.errorText("paymentOptions")}
                                            >
                                                <MenuItem value="Direct Deposit">Direct Deposit</MenuItem>
                                            </TextField>
                                        </Grid>
        
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="nextInvoiceNumber"
                                                label="Next Invoice Number"
                                                margin="dense"
                                                fullWidth
                                                value={nextInvoiceNumber}
                                                onChange={this.handleNextInvoiceNumberChange}
                                                error={this.anyError("nextInvoiceNumber")}
                                                helperText={this.errorText("nextInvoiceNumber")}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                { (isAgent || isMusician) ?
                                    <Grid item xs={12} md={12}>
                                        <Grid item xs={12} md={5}>
                                            <Switch checked={outgoingToggleAddress} onChange={this.handleToggleOutgoingAddress} value="hideToolbar" /> Set legal entity for outgoing invoices
                                        </Grid>
                                    </Grid> : null
                                }

                                {
                                    outgoingToggleAddress ? 
                                    <Grid xs={12} md={12}>
                                         <Grid container spacing={8}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="legalEntityNameOutgoing"
                                                label="Legal Entity Name"
                                                margin="dense"
                                                fullWidth
                                                value={outgoingEntityName}
                                                onChange={this.setOutgoingEntityName}
                                                error={this.anyError("legalEntityNameOutgoing")}
                                                helperText={this.errorText("legalEntityNameOutgoing")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="emailOutgoingEmail"
                                                label="Email"
                                                margin="dense"
                                                fullWidth
                                                value={outgoingInvoiceEmail}
                                                onChange={this.setOutgoingInvoiceEmail}
                                                error={this.anyError("emailOutgoingEmail")}
                                                helperText={this.errorText("emailOutgoingEmail")}
                                            />
                                        </Grid>
                                        </Grid>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12} lg={8}>
                                                <TextField
                                                    id="streetOutgoing"
                                                    label="Street Address"
                                                    margin="dense"
                                                    fullWidth
                                                    value={streetOutgoing}
                                                    onChange={this.handleStreetChangeOutgoing}
                                                    error={this.anyError("streetOutgoing")}
                                                    helperText={this.errorText("streetOutgoing")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="cityOutgoing"
                                                    label="Suburb"
                                                    margin="dense"
                                                    fullWidth
                                                    value={cityOutgoing}
                                                    onChange={this.handleCityChangeOutgoing}
                                                    error={this.anyError("cityOutgoing")}
                                                    helperText={this.errorText("cityOutgoing")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="stateOutgoing"
                                                    label="State"
                                                    margin="dense"
                                                    fullWidth
                                                    value={stateOutgoing}
                                                    onChange={this.handleStateChangeOutgoing}
                                                    error={this.anyError("stateOutgoing")}
                                                    helperText={this.errorText("stateOutgoing")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="postalOutgoing"
                                                    label="Postal/Zip Code"
                                                    margin="dense"
                                                    fullWidth
                                                    value={postalOutgoing}
                                                    onChange={this.handlePostalChangeOutgoing}
                                                    error={this.anyError("postalOutgoing")}
                                                    helperText={this.errorText("postalOutgoing")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4} className="select-field-country">
                                                <SelectField
                                                    id="countriesOutgoing"
                                                    multi={false}
                                                    suggestions={countriesSuggestion()}
                                                    onChange={this.handleCountryChangeOutgoing}
                                                    value={countryCodeOutgoing}
                                                    placeholder=" "
                                                    label="Country"
                                                    margin="dense"
                                                    error={this.anyError("countriesOutgoing")}
                                                    helperText={this.errorText("countriesOutgoing")}
                                                />
                                            </Grid>

                                           
                                            </Grid>
                                        
                                    </Grid>
                                     : null
                                }
                                </Grid>
                            </Fragment>
                        }
                     

                        <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Incoming Invoices"
                                helpText={type === "venue" ? venueIncomingInvoice : type === "musician" ? musicianIncomingInvoice : agentIncomingInvoice}
                            />
                            {type !== "venue" && (
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="paymentTerms"
                                        label="Incoming Invoices Batching"
                                        select
                                        margin="dense"
                                        fullWidth
                                        value={paymentTerms}
                                        onChange={this.handlePaymentTermsChange}
                                        error={this.anyError("paymentTerms")}
                                        helperText={this.errorText("paymentTerms") || "Incoming Invoices will be batched by this option"}
                                    >
                                        <MenuItem value="0">One invoice per gig</MenuItem>
                                        <MenuItem value="7">Weekly</MenuItem>
                                        <MenuItem value="14">Fortnightly</MenuItem>
                                        <MenuItem value="30">Monthly</MenuItem>
                                    </TextField>
                                </Grid>)
                                }
                                {type === "venue" && (
                                <Grid container spacing={8}> 
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="paymentTerms"
                                        label="Incoming Invoices Batching"
                                        select
                                        margin="dense"
                                        fullWidth
                                        value={paymentTerms}
                                        onChange={this.handlePaymentTermsChange}
                                        error={this.anyError("paymentTerms")}
                                        helperText={this.errorText("paymentTerms") || "Incoming Invoices will be batched by this option"}
                                    >
                                        <MenuItem value="0">One invoice per gig</MenuItem>
                                        <MenuItem value="7">Weekly</MenuItem>
                                        <MenuItem value="14">Fortnightly</MenuItem>
                                        <MenuItem value="30">Monthly</MenuItem>
                                    </TextField>
                                    </Grid>
                                </Grid>
                                )}
                                
                                <Grid item xs={12} md={12}>
                                    <Grid item xs={12} md={5}>
                                        <Switch checked={incomingToggleAddress} onChange={this.handleToggleIncomingAddress} value="hideToolbar" /> Set legal entity for incoming invoices
                                    </Grid>
                                </Grid>

                                {
                                    incomingToggleAddress ? 
                                    <Grid xs={12} md={12}>
                                        <Grid container spacing={8}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="legalEntityNameIncoming"
                                                label="Legal Entity Name"
                                                margin="dense"
                                                fullWidth
                                                value={incomingEntityName}
                                                onChange={this.setIncomingEntityName}
                                                error={this.anyError("legalEntityNameIncoming")}
                                                helperText={this.errorText("legalEntityNameIncoming")}
                                            />
                                        </Grid>
                                        
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                id="emailInvoicesOutgoing"
                                                label="Email"
                                                margin="dense"
                                                fullWidth
                                                value={incomingInvoiceEmail}
                                                onChange={this.setIncomingInvoiceEmail}
                                                error={this.anyError("street")}
                                                helperText={this.errorText("street")}
                                            />
                                        </Grid>
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12} lg={8}>
                                                <TextField
                                                    id="streetIncoming"
                                                    label="Street Address"
                                                    margin="dense"
                                                    fullWidth
                                                    value={streetIncoming}
                                                    onChange={this.handleStreetChangeIncoming}
                                                    error={this.anyError("streetIncoming")}
                                                    helperText={this.errorText("streetIncoming")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="cityIncoming"
                                                    label="Suburb"
                                                    margin="dense"
                                                    fullWidth
                                                    value={cityIncoming}
                                                    onChange={this.handleCityChangeIncoming}
                                                    error={this.anyError("cityIncoming")}
                                                    helperText={this.errorText("cityIncoming")}
                                                />
                                            </Grid>

                                           

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="stateIncoming"
                                                    label="State"
                                                    margin="dense"
                                                    fullWidth
                                                    value={stateIncoming}
                                                    onChange={this.handleStateChangeIncoming}
                                                    error={this.anyError("stateIncoming")}
                                                    helperText={this.errorText("stateIncoming")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4}>
                                                <TextField
                                                    id="postalIncoming"
                                                    label="Postal/Zip Code"
                                                    margin="dense"
                                                    fullWidth
                                                    value={postalIncoming}
                                                    onChange={this.handlePostalChangeIncoming}
                                                    error={this.anyError("postalIncoming")}
                                                    helperText={this.errorText("postalIncoming")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} lg={4} className="select-field-country">
                                                <SelectField
                                                    id="countriesIncoming"
                                                    multi={false}
                                                    suggestions={countriesSuggestion()}
                                                    onChange={this.handleCountryChangeIncoming}
                                                    value={countryCodeIncoming}
                                                    placeholder=" "
                                                    label="Country"
                                                    margin="dense"
                                                    error={this.anyError("countriesIncoming")}
                                                    helperText={this.errorText("countriesIncoming")}
                                                />
                                            </Grid>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                     : null
                                }
                        </Grid>
                        { currentProfile?.type === ProfileType.Agent.ordinal ? 

                        <Grid container spacing={8}>
                              <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Fee Transparancy"
                                helpText={feeTransparancy}
                            />
                        <Grid container spacing={8}> 
                        <Grid item xs={12} md={6}>Venues</Grid>
                        <Grid item xs={12} md={6}>Artist</Grid>
                        </Grid>

                        <Grid container spacing={8}> 
                                    <Grid item xs={12} md={6}>
                                        <Switch checked={hideVenueAgencyFees} onChange={this.handleToggleHideVenueAgencyFees} value="hideToolbar" /> Hide Agency Fees
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                    <Switch checked={hideArtistAgencyFees} onChange={this.handleToggleHideArtistAgencyFees} value="hideToolbar" /> Hide Agency Fees
                                    </Grid>
                                    </Grid>
                                    <Grid container spacing={8}> 
                                    <Grid item xs={12} md={6}>
                                    <Switch checked={hideActFees} onChange={this.handleToggleHideActFees} value="hideToolbar" /> Hide Act Fees
                                        
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Switch checked={hideVenueFees} onChange={this.handleToggleHideVenueFees} value="hideToolbar" /> Hide Venue Fees
                                    </Grid>
                                    </Grid>

                        </Grid>
                        </Grid> : null
                        }
                      

                        {/* {type !== 'venue' && 
                        <Fragment>
                            <Grid item xs={12} lg={3}>
                                <div className="sticky-information">
                                    <Typography variant="headline" component="h3" gutterBottom>
                                        Insurance
                                    </Typography>
                                    <Fragment>
                                        <Typography gutterBottom className="side-helper-text">
                                            Enter your insurance information here. Some venues require this information for the booking worksheet.
                                        </Typography>
                                    </Fragment>
                                </div>
                            </Grid>
                            <Grid item xs={12} lg={9}>
                                <Grid container spacing={8}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="insuranceName"
                                            label="Policy Holder Name"
                                            margin="dense"
                                            fullWidth
                                            value={insuranceName}
                                            onChange={this.handleInsuranceNameChange}
                                            error={this.anyError("insuranceName")}
                                            helperText={this.errorText("insuranceName")}
                                        />
                                    </Grid>
    
                                    <Grid item xs={12} md={6}>
                                    <TextField
                                            id="insuranceCompany"
                                            label="Insurance Company"
                                            margin="dense"
                                            fullWidth
                                            value={insuranceCompany}
                                            onChange={this.handleInsuranceCompanyChange}
                                            error={this.anyError("insuranceCompany")}
                                            helperText={this.errorText("insuranceCompany")}
                                        />
                                    </Grid>
    
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="policyNumber"
                                            label="Policy Number"
                                            margin="dense"
                                            fullWidth
                                            value={policyNumber}
                                            onChange={this.handlePolicyNumberChange}
                                            error={this.anyError("policyNumber")}
                                            helperText={this.errorText("policyNumber")}
                                        />
                                    </Grid>
    
                                    <Grid item xs={12} lg={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                id="booking-date"
                                                className="booking-date-picker"
                                                keyboard
                                                value={insuranceExpiryDate}
                                                fullWidth
                                                margin="dense"
                                                onChange={this.handleDateStartChange}
                                                label="Expiry Date"
                                                minDate={moment().startOf("day")}
                                                format="DD-MM-YYYY"
                                                keyboardIcon={<EventIcon />}
                                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                                style={{ marginTop: 0 }}
                                                shouldDisableDate={this.shouldDisabledDate}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Fragment>
                        } */}
                        <Grid item xs={12}>
                            <div className="action">
                                <Button disabled={editProfileActiveStep === 0} onClick={this.handleBack}>
                                    Back
                                </Button>
                                <Button variant="contained" color="primary" type="submit">
                                    {editProfileActiveStep === steps.length - 1 ? "Finish" : "Save/Next"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
                <ConfirmationModal
                    open={this.state.dialogAutoSendPopUp}
                    message="Turning on this feature will automatically send your invoices to accounts at midnight, on the Monday after the end of the incoming invoices batching period. If you select One Invoice Per Gig, the batch will be sent on Monday after the week end. Your current incoming invoices batching is set to {incoming invoices batching period}. Do you want to continue?"
                    title="Activate auto ‘Send To Accounts’"
                    closeHandler={this.closeDialogAutoSendPopUp}
                    confirmationHandler={this.handleAutoSendChange}
                    declineHandler={this.closeDialogAutoSendPopUp}
                    confirmationLabel="Confirm"
                    maxWidth="md"
                />
                  <ConfirmationModal
                    open={this.state.dialogAutoSendOffPopUp}
                    message="Turning off this feature will mean artist invoices are no longer automatically sent to accounts. Do you want to continue?"
                    title="Deactivate auto ‘Send To Accounts’"
                    closeHandler={this.closeDialogAutoSendOffPopUp}
                    confirmationHandler={this.handleAutoSendChange}
                    declineHandler={this.closeDialogAutoSendOffPopUp}
                    confirmationLabel="Confirm"
                    maxWidth="md"
                />
                   <ConfirmationModal
                        open={this.state.openConfirmationDialog}
                        title="Confirmation"
                        message={legalEntityHasSuper(this.props.financialProfileStore.legalEntity) ? `Changing your legal entity will update the super calculation for all future bookings. Are you sure you want to continue?` : `Changing to ${legalEntitySuggestions.filter(x=>x.value === this.props.financialProfileStore.legalEntity)[0]?.label} will mean that super payments for all future bookings will be removed.  You can only this setting once every 30 days.  Do you want to continue?`}
                        closeHandler={this.closeConfirmDialog}
                        confirmationHandler={this.handleSubmitForm}
                        declineHandler={this.closeConfirmDialog}
                        confirmationLabel="Confirm"
                    />

                <Dialog
                    open={this.state.tcDialogOpen}
                    onClose={() => this.setState({ tcDialogOpen: false })}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>Terms &amp; Conditions</DialogTitle>
                    <DialogContent style={{ padding: 0, height: "80vh" }}>
                        <iframe
                            src="https://get.hotgiggity.com/tos"
                            title="Terms & Conditions"
                            style={{ width: "100%", height: "100%", border: "none" }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ tcDialogOpen: false })} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}

export default Financial;
